import { useMemo } from 'react';
import { MutationConfig, MutationFunction, MutationResultPair } from '../types/dataMutation';
import { useMutation } from '@tanstack/react-query';

export function useMutationV5<TResult, TError = unknown, TVariables = unknown>(
	mutationFn: MutationFunction<TResult, TVariables>,
	config?: MutationConfig<TResult, TError, TVariables>,
) {
	const {
		// mutate: mutation,
		mutateAsync,
		status,
		data,
		error,
		isPending: isLoading,
		isSuccess,
		isError,
	} = useMutation<TResult, TError, TVariables>({
		mutationFn,
		onMutate: config?.onMutate,
		onSuccess: config?.onSuccess,
		onSettled: config?.onSettled,
		onError: config?.onError,
		throwOnError: config?.throwOnError,
	});

	return useMemo<MutationResultPair<TResult, TError, TVariables, unknown>>(() => {
		return [
			mutateAsync,
			{
				status,
				data,
				error,
				isLoading,
				isSuccess,
				isError,
			},
		];
	}, [data, error, isError, isLoading, isSuccess, mutateAsync, status]);
}
